module.exports = __webpack_public_path__ + "img/reportSilde.4f39ac18.png";